module.exports = __webpack_public_path__ + "media/images/about/time/4-822f4a9f8f16bb89ad1011c0d3b5e73d.png";